<h3 class="display-10">{{ 'store.invitation.detailsTitle' | translate }}</h3>
<form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
  <div class="form-group mb-4">
    <header class="header-input-filed ">{{ 'store.invitation.profilePhoto' | translate }}</header>
    <div class="upload-image-container" (click)="logoUploader.click()">
      <div *ngIf="!logoPreview" class="image-container">
        <img src="assets/images/camera.png" alt="store-image">
      </div>
      <img *ngIf="logoPreview" [src]="logoPreview" alt="logo">
      <div class="upload-text">{{ 'store.invitation.uploadPhoto' | translate }}</div>
    </div>
    <input style="display: none" type="file" #logoUploader accept="image/*" (change)="onLogoChange($event)">
    <div class="form-group mb-4">
      <header class="header-input-filed ">{{ 'store.settings.category' | translate }}</header>
      <select [ngClass]="{ 'is-invalid': submitted && f.cat.errors }" formControlName="cat" class="select-category"
              name="cars" id="cars">
        <option *ngFor="let category of categoryList" [value]="category.id">{{category.name}}</option>
      </select>
      <div *ngIf="submitted && f.cat.errors" class="invalid-feedback">
        <div *ngIf="f.cat.errors.required">{{ 'store.invitation.categoryRequired' | translate }}</div>
      </div>
    </div>
  </div>
  <div class="btns-container">
    <a class="a-padding" (click)="onSubmit(true)">{{ 'common.back' | translate }}</a>
    <button type="submit" class="btn btn-primary">{{ 'common.next' | translate }}</button>
  </div>
</form>
